var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { AbfragerKnowAWordInputRow } from './AbfragerKnowAWordInputRow';
import { AbfragerQuestionAnswerPart } from '../../scenes/showQuestion/AbfragerQuestionAnswerPart';
let AbfragerKnowAWordAnswerPart = class AbfragerKnowAWordAnswerPart extends React.PureComponent {
    render() {
        const { question } = this.props;
        return (React.createElement(AbfragerQuestionAnswerPart, { question: question },
            React.createElement("div", { style: { display: 'flex', flexDirection: 'column', flex: '1 1 auto' } },
                React.createElement(AbfragerKnowAWordInputRow, { question: question }))));
    }
};
AbfragerKnowAWordAnswerPart = __decorate([
    observer
], AbfragerKnowAWordAnswerPart);
export { AbfragerKnowAWordAnswerPart };
